// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"844":"antiAgingPaket","962":"home"}[chunkId] + "." + {"844":"1ef07096","962":"ca6b34ca"}[chunkId] + ".css";
};